export const defaultCurrencyCode = 'USD';
